 <!--
  2019-2-14, AJK, created file
  2019-2-20, AJK, updated to check for match between old and new password
  2019-3-06, AJK, updated to use snotify 
 -->


<template>
  <div class="users container">
    <b-loading :active.sync="isLoading"/>
      <form action="">
          <div class="modal-card" style="width: 2000">
              <header class="modal-card-head">
                  <p class="modal-card-title">Checkout</p>
              </header>
              <section class="modal-card-body">

                <!-- FIRST PANEL - PAYMENT, NOTES, SHIPPING METHOD-->
                <div v-if="isPanelOne" class="panelOne">
                  <!-- INPUT FOR PAYMENT -->
                  <div v-if="userInfo.isAllowedToPayWithCheck || userInfo.isAllowedToPayWithACH">
                    <div class="is-flex is-justify-content-space-between">
                      <div v-if="userInfo.isAllowedToPayWithCheck" class="payWithCheck">
                        <b-field>
                          <b-checkbox v-model="useCheck" size="is-medium"><strong :class="{ greyOut: useACH }">I Will Pay With Check</strong></b-checkbox>
                        </b-field>
                      </div>
                      <div v-if="userInfo.isAllowedToPayWithACH" class="payWithCheck">
                        <b-field>
                          <b-checkbox v-model="useACH" size="is-medium"><strong :class="{ greyOut: useCheck }">I Will Pay With ACH</strong></b-checkbox>
                        </b-field>
                      </div>
                    </div>
                    <div class="divider"></div>
                  </div>
                  <div class="topHalf">
                    <div class="flexDivLeft">
                      <b-field  class="" v-if="cc.length" label="Credit Card">
                        <b-select :disabled="useCheck || useACH" size="is-medium" v-model="card" placeholder="Select a Credit Card" expanded>
                            <option
                                v-for="card in cc"
                                :value="card"
                                :key="card.__kptID">
                                {{card.sqCardBrand}} - {{ card.sqCardLast4 }} - {{card.sqCardExp}}
                            </option>
                        </b-select>
                      </b-field>
                      <p v-else>You have no valid credit cards on file.</p>
                      <div class="newccbutton">
                        <button :disabled="useCheck || useACH" @click="addNewCard()" class="button is-primary">New Credit Card</button>
                      </div>
                    </div>
                    <div class="flexDivRight">
                        <b-field label="Shipping Method">
                        <b-select v-model="shippingMethodChosen" size="is-medium" placeholder="Select a shipping method..." expanded>
                            <option
                                v-for="shippingMethod in shippingMethods"
                                :value="shippingMethod"
                                :key="shippingMethod">
                                {{shippingMethod}}
                            </option>
                        </b-select>
                      </b-field>
                    </div> 
                  </div>
                  <!-- INPUT FOR ORDER NOTES -->
                  <b-field label="Special Notes or POS Material Requests">
                      <b-input
                          v-model="cart.notes"
                          type="textarea"
                          placeholder="Please send new bin tags for Colombian and Peruvian Decaf">
                      </b-input>
                  </b-field>
                  <!-- <b-checkbox v-model="cart.isRepeated">Make this a recurring order...</b-checkbox> -->
                  <div v-if="cart.isRepeated">
                  <b-field label="Every...">
                    <div class="level">
                      <div class="level-left">
                          <b-select
                              class="level-item"
                              v-model="cart.weeks"
                              placeholder="#"> 
                              <option value="1">1</option>
                              <option value="2">2</option>
                              <option value="3">3</option>
                              <option value="4">4</option>
                              <option value="4">6</option>
                              <option value="4">8</option>
                          </b-select>
                          <p>&nbsp;weeks</p>
                        </div>
                      </div>
                  </b-field> 
                  </div>
                </div>

                <!-- SECOND PANEL - ADDRESS CONFIRMATION -->
                <div v-if="isPanelTwo" class="panelOne">
                  <h1>Please confirm that the following information on file is correct:</h1>

                  <br>
                  <button v-on:click="goToUserInfo()" class="button is-pulled-right">Edit</button>
                  <div class="columns">
                    <div class="column is one-third">
                      <p><strong>User Information</strong></p>
                      <p>{{results.nameFull}}</p>
                      <p>{{results.companyName}}</p>
                      <p>{{results.email}}</p>
                      <p>{{results.phoneNumber}}</p>
                      <br>
                    </div>
                    <div class="column is one-third">
                      <p><strong>Billing Address</strong></p>
                      <p>{{results.billingAddressLine1}}</p>
                      <p v-if="results.billingAddressLine2">{{results.billingAddressLine2}}</p>
                      <p>{{results.billingAddressCity}}, {{results.billingAddressState}} {{results.billingAddressZip}}</p>
                      <p>{{results.billingAddressCountry}}</p>
                      <br>
                    </div>
                  </div>
                  
                  <div style="margin-left:1rem;">
                    <button v-on:click="goToUserAddressUpdate()" class="button is-pulled-right"  v-if="shippingAddresses.length != 1">Edit</button>
                    <p><strong>Shipping Address</strong></p>
                    <div  v-if="shippingAddresses.length == 1"><button v-if="shippingAddresses.length == 1" v-on:click="goToUserAddressUpdate(true)" class="addAddress button is-primary">Please add an Address</button></div>
                    <div v-if="shippingAddresses.length != 1">
                      <p>{{selectedAddress.name}}</p>
                      <p>{{selectedAddress.shippingLine1}}</p>
                      <p v-if="selectedAddress.shippingLine2">{{selectedAddress.shippingLine2}}</p>
                      <p>{{selectedAddress.shippingCity}}, {{selectedAddress.shippingState}} {{selectedAddress.shippingZip}}</p>
                      <p>{{selectedAddress.shippingCountry}}</p>
                    </div>
                  </div>
                </div>

                <!-- THIRD PANEL - UPDATE ADDRESS/PERSONAL INFORMATION -->
                <div v-if="isPanelThree" class="panelOne">

                  <div class="columns ">
                    <div class="column is-one-half">
                    <h1>Please update your information:</h1>
                        <b-field label="First Name">
                        <b-input v-model="results.nameFirst"/>
                        </b-field>
                        <b-field label="Last Name">
                        <b-input v-model="results.nameLast"/>
                        </b-field>
                        <b-field label="Username/Email">
                        <b-input type="email" v-model="results.email"/>
                        </b-field>
                        <b-field label="Phone">
                        <b-input v-model="results.phoneNumber"/>
                        </b-field>
                    </div>
                    <div class="column is-one-half">
                        <h1>Billing Address</h1>
                        <b-field label="Line 1">
                        <b-input v-model="results.billingAddressLine1"/>
                        </b-field>
                        <b-field label="Line 2">
                        <b-input v-model="results.billingAddressLine2"/>
                        </b-field>
                        <b-field label="City">
                        <b-input v-model="results.billingAddressCity"/>
                        </b-field>
                        <b-field label="State">
                        <b-input v-model="results.billingAddressState"/>
                        </b-field>
                        <b-field label="Postal Code">
                        <b-input v-model="results.billingAddressZip"/>
                        </b-field>
                        <b-field label="Country">
                        <b-input v-model="results.billingAddressCountry"/>
                        </b-field>
                    </div>
                  </div>
                </div>

                <!-- FOURTH PANEL - NEW ADDRESS-->
                <div v-if="isPanelFour" class="panelOne">

                  <b-field class="" label="Select an address on file or add new...">
                    <b-select v-model="selectedAddress" placeholder="Select an Address..." expanded>
                        <option
                            v-for="address in shippingAddresses"
                            :value="address"
                            :key="address.__kptID">
                            {{address.name}} - {{address.shippingLine1}}
                        </option>
                    </b-select>
                  </b-field>

                  <newAddress 
                    v-on:update="update" 
                    :isUpdate="selectedAddress.__kptID == 'New Address...' ? false : true" 
                    :isNew="selectedAddress.__kptID == 'New Address...' ? true : false" 
                    :isFromCheckout="true"
                    :AddressID="selectedAddress.__kptID == 'New Address...' ? '' : selectedAddress.__kptID" 
                    :Address="selectedAddress.__kptID == 'New Address...' ? {} : selectedAddress"
                  >
                  </newAddress>

                </div>

                <!-- FIFTH PANEL - ORDER CONFIRMATION -->
                <div v-if="isPanelFive" class="panelOne">
                  <h1>Please confirm that the following information on file is correct:</h1>
                  <br>

                  <div class="">
                    <div class="">
                      <p><strong>Cart</strong></p>
                      <table class="checkoutTable">
                        <tr>
                          <th></th>
                          <th></th>
                          <th></th>
                        </tr>
                        <tr v-for="product in cart.products" :key="product.__kptID" class="tableRow">
                          <td>{{product.productName}}</td>
                          <td>{{product.quantity}}x</td>
                          <td class="is-pulled-right">{{product.price | currency}}</td>
                        </tr>
                      </table>

                      <br>
                      <h1 class="is-pulled-right"><strong>Total: {{cart.total | currency }}</strong></h1>
                    </div>

                    <br>
                    <div class="divline"></div>

                    <div class="addressFlex">

                      <div class="addressFlexItem">
                        <p><strong>Billing Address</strong></p>
                        <p>{{results.billingAddressLine1}}</p>
                        <p v-if="results.billingAddressLine2">{{results.billingAddressLine2}}</p>
                        <p>{{results.billingAddressCity}}, {{results.billingAddressState}} {{results.billingAddressZip}}</p>
                        <p>{{results.billingAddressCountry}}</p>
                        <br>
                      </div>

                      <div class="addressFlexItem">
                        
                        <p><strong>Shipping Address</strong></p>
                        <p>{{selectedAddress.name}}</p>
                        <p>{{selectedAddress.shippingLine1}}</p>
                        <p v-if="selectedAddress.shippingLine2">{{selectedAddress.shippingLine2}}</p>
                        <p>{{selectedAddress.shippingCity}}, {{selectedAddress.shippingState}} {{selectedAddress.shippingZip}}</p>
                        <p>{{selectedAddress.shippingCountry}}</p>
                      </div>

                    </div>
                  </div>


                  <b-checkbox v-model="acknowledgeShippingCosts">I understand that shipping costs are not included in this total, and will be added before final payment.</b-checkbox>
                  <br>
                  <br>
                  <b-checkbox v-model="cart.isDefaultSetting">I agree to allow Dean's Beans to place this order and charge my wholesale account with any payment methods on file.</b-checkbox>
                  <br>
                  <br>
                  <b-checkbox v-model="isMarketingEmail">Need Updated Marketing Materials? Check here and a member of our marketing team will be in touch.</b-checkbox>
                  <br>
                </div>

              </section>

              <footer class="modal-card-foot">
                  <!-- panel 5 -->
                  <b-button class="button is-primary" type="button" v-if="isPanelFive" outlined @click="isPanelOne = true, isPanelTwo = false, isPanelThree = false, isPanelFour = false, isPanelFive = false ">Back</b-button>
                  <b-button class="button is-primary" type="button" v-if="isPanelFive" @click="checkOut()">Place Order</b-button>
                  <!-- panel 4 -->
                  <b-button class="button is-primary" type="button" v-if="isPanelFour" outlined @click="addressCancel()">Cancel</b-button>
                  <b-button class="button is-primary" type="button" v-if="isPanelFour" :style="{ 'background-color': buttonColor(selectedAddress.__kptID == 'New Address...') }" @click="addressCancel(false)">Continue with Selected Address</b-button>
                  <!-- panel 3 -->
                  <b-button class="button is-primary" type="button" v-if="isPanelThree" outlined @click="isPanelTwo = true, isPanelOne = false, isPanelThree = false, isPanelFour = false, isPanelFive = false ">Cancel</b-button>
                  <b-button class="button is-primary" type="button" v-if="isPanelThree" :style="{ 'background-color': buttonColor(cantUpdate) }" @click="updateUserInfo()">Update</b-button>
                  <!-- panel 2 -->
                  <b-button class="button is-primary" type="button" v-if="isPanelTwo" outlined @click="closeWindow($parent)">Back</b-button>
                  <b-button class="button is-primary" type="button" v-if="isPanelTwo" @click="nextPanelCC()">Next</b-button>
                  <!-- panel 1 -->
                  <b-button class="button is-primary" type="button" v-if="isPanelOne" outlined @click="isPanelOne = false, isPanelTwo = true, isPanelThree = false, isPanelFour = false, isPanelFive = false ">Back</b-button>
                  <b-button class="button is-primary" type="button" v-if="isPanelOne" @click="nextPanel()">Next</b-button>

              </footer>
          </div>
      </form>
  </div>
</template>

<script>
// @ is an alias to /src
import newAddress from '@/components/NewAddress'
import userAPI from '@/api/UserAPI.js'
import sharedAPI from '@/api/SharedAPI.js'
import { mapMutations, mapState, mapGetters  } from 'vuex'
import store from '../store.js'
import axios from "axios";


export default {
  components: {
    'newAddress': newAddress
  },
  name: 'Confirmation',
  props: ['passwordChangeNeeded', 'defaultCardID', 'panel'],
  data () {
    return {
        acknowledgeShippingCosts: false,
        isLoading: false,
        isPanelOne: false,
        isPanelTwo: true,
        isPanelThree: false,
        isPanelFour: false,
        isPanelFive: false,
        hasNoShippingAddresses: false,
        results: {},
        originalObject: {},
        cc: [],
        card: null,
        shippingMethodChosen: null,
        shippingMethods: [ 'UPS - Ground','UPS - 3 Day Select','UPS - 2nd Day Air','UPS - Next Day Air'],
        shippingAddresses: [],
        selectedAddress: null,
        useCheck: false,
        useDelivery: false,
        usePickUp: false,
        useACH: false,
        isMarketingEmail: false,
    }
  },
  
  computed: {
  ...mapState([
      'cart', 'userInfo'
    ]),

    cantUpdate: function() {
      if (
        this.originalObject.nameFirst == this.results.nameFirst &&
        this.originalObject.nameLast == this.results.nameLast &&
        this.originalObject.email == this.results.email &&
        this.originalObject.phoneNumber == this.results.phoneNumber &&    
        this.originalObject.billingAddressLine1 == this.results.billingAddressLine1 &&
        this.originalObject.billingAddressLine2 == this.results.billingAddressLine2 &&
        this.originalObject.billingAddressCity == this.results.billingAddressCity &&
        this.originalObject.billingAddressState == this.results.billingAddressState &&
        this.originalObject.billingAddressZip == this.results.billingAddressZip &&
        this.originalObject.billingAddressCountry == this.results.billingAddressCountry
      ) {
          return true
      }
      else{
          return false
      }
    },
  },

  filters: {
    currency: function(price){
      return "$".concat(price.toFixed(2));
    }
  },

  watch: {
    useCheck (value){
      if (value && this.userInfo.isAllowedToPayWithACH){
        this.useACH = false
      }
    },
    useACH (value){
      if (value && this.userInfo.isAllowedToPayWithCheck){
        this.useCheck = false
      }
    }
  },

  mounted() {
    this.loadCCData()
    this.loadData()
    this.loadShippingData()
  },
  
  methods:{ 
    
    ...mapMutations([
    "setCampaigns",
    "setEmails",
    "setCampaignsAndEmails",
    "setSelectedCampaign",
    "setCart"
    ]),

    closeWindow: function(parent) {
      var self = this
      parent.close()
      self.cart.isDefaultSetting = false
    },

    nextPanel: function(){
      var self = this
      var cardID = self.card ? self.card.__kptID : null

      if(!cardID && !this.useCheck && !this.useACH){
          //requires a card
          self.$root.$children[0].$refs.toast.error("Please select a payment method", "Error!")
          return
      }
      if(!self.shippingMethodChosen){
          //requires a shipping type
          self.$root.$children[0].$refs.toast.error("Please select shipping method", "Error!")
          return
      }

      self.isPanelOne = false
      self.isPanelTwo = false
      self.isPanelThree = false
      self.isPanelFour = false
      self.isPanelFive = true
      // self.loadData()
    },

    goToUserInfo: function(){
      var self = this
      self.isPanelOne = false
      self.isPanelTwo = false
      self.isPanelThree = true
      self.isPanelFour = false
      self.isPanelFive = false
    },

    goToUserAddressUpdate: function(isNew = false){
      var self = this
      if(isNew){
        this.selectedAddress = { 
          name: "New Address...",
          __kptID: "New Address..."
        }
      }
      self.isPanelOne = false
      self.isPanelTwo = false
      self.isPanelThree = false
      self.isPanelFour = true
      self.isPanelFive = false
    },


    loadData: async function(){
      var self = this
      self.isLoading = true
      const query = `{
          "query":[
              {"__kptID": "${self.userInfo.userID}"}
          ]
      }`
      const result = await userAPI.find(query)
      if(result.messages[0].code !== "0"){
        self.isLoading = false
        self.$toast.open({
          duration: 4000,
          message: result.messages[0].message,
          position: 'is-bottom',
          type: 'is-danger'
        })
        return
      }  
      self.results = result.response.data[0].fieldData
      self.originalObject = {...self.results}
      if (self.panel == 1){
        self.isPanelOne = true
        self.isPanelTwo = false
        self.isPanelThree = false
        self.isPanelFour = false
        self.isPanelFive = false
      }else if(self.panel == 2){
        self.isPanelOne = false
        self.isPanelTwo = true
        self.isPanelThree = false
        self.isPanelFour = false
        self.isPanelFive = false
      }else if(self.panel == 3){
        self.isPanelOne = false
        self.isPanelTwo = false
        self.isPanelThree = true
        self.isPanelFour = false
        self.isPanelFive = false
      }
      this.isLoading = false
      
      if( this.userInfo.isAllowedToHaveOrderDelivered ){
        this.shippingMethods.unshift("Dean's Beans Local Delivery")
      }

      if( this.userInfo.isAllowedToHaveOrderPickedUp ){
        this.shippingMethods.unshift("Dean's Beans Local Pickup")
      }
    },

    buttonColor: function(param){
      if(param == true){
        return 'grey'
      }else{
        return ''
      }
    },

    updateUserInfo: async function(){
      var self = this

      if(this.cantUpdate){
          self.$root.$children[0].$refs.toast.error("Nothing to update", "Error")
          return
      }
      this.isLoading = true

      if (this.results.includeOnMap == true) {
        var includeOnMap = 1
      }
      else {
        var includeOnMap = 0
      }
      this.isLoading = true
      var fieldData = `{
        "fieldData" : {
          "nameFirst" : "${this.results.nameFirst}",
          "nameLast"  : "${this.results.nameLast}",
          "email"  : "${this.results.email}",
          "phoneNumber"  : "${this.results.phoneNumber}",
          "billingAddressLine1"     : "${this.results.billingAddressLine1}",
          "billingAddressLine2" : "${this.results.billingAddressLine2}",
          "billingAddressCity"  : "${this.results.billingAddressCity}",
          "billingAddressCountry"  : "${this.results.billingAddressCountry}",
          "billingAddressZip"     : "${this.results.billingAddressZip}",
          "billingAddressState"     : "${this.results.billingAddressState}"
        }
      }`
      // console.log(fieldData)

      const response = await userAPI.updateRecord(fieldData, this.userInfo.recID)
      if(response.messages[0].code == "0"){
        this.isLoading = false
        this.originalObject = {...this.results}
        // this.isPanelTwo = true
        // this.isPanelOne = false
        // this.isPanelThree = false
        self.$root.$children[0].$refs.toast.success("User Info Updated!", "Success")
        // this.nextPanel()
        self.isPanelTwo = true
        self.isPanelThree = false
        return
      } 
      else{
        this.isLoading = false
        self.$root.$children[0].$refs.toast.error("Could not update", "Error")
      }
      // this.results = result.response.data[0].fieldData
      this.isLoading = false

    },
 
    nextPanelCC(){
      var self = this
      if (self.selectedAddress == null){
          self.$root.$children[0].$refs.toast.error("Please enter a shipping address", "Error!")
          return
      }
      if (self.results.billingAddressLine1 == "" || self.results.billingAddressLineCity == "" || self.results.billingAddressState == "" || self.results.billingAddressZip == ""){
          self.$root.$children[0].$refs.toast.error("Please enter a complete billing address", "Error!")
          return
      }
      this.isPanelOne = true
      this.isPanelTwo = false
      this.isPanelThree = false
      this.isPanelFour = false
      self.isPanelFive = false
    },

    checkOut: async function(){
      var self = this

      //check if they agreed to terms
      if (self.acknowledgeShippingCosts == false){
          self.$root.$children[0].$refs.toast.error("Must acknowledge shipping costs will be added.", "Error!")
          return
      }
      if (self.cart.isDefaultSetting == false){
          self.$root.$children[0].$refs.toast.error("Must agree to terms and conditions.", "Error!")
          return
      }

      if (self.results.billingAddressLine1 == "" || self.results.billingAddressLineCity == "" || self.results.billingAddressState == "" || self.results.billingAddressZip == ""){
          self.$root.$children[0].$refs.toast.error("Please enter a complete billing address", "Error!")
          return
      }

      self.isLoading = true
      self.cart.wholesalerID = self.userInfo.userID
      self.cart.cardID = self.card ? self.card.__kptID : ''
      self.cart.shippingMethod = self.shippingMethodChosen
      self.cart.address = self.selectedAddress
      self.cart.useCheck = self.useCheck
      self.cart.useACH = self.useACH
      self.cart.isMarketingEmail = self.isMarketingEmail
      var scriptParameters = JSON.stringify(self.cart)
      const result = await sharedAPI.runScript("Order Request - Web Log - Add Order", scriptParameters)
      var scriptResult = JSON.parse(result.response.scriptResult)
      self.isLoading = false
      // FM error
      if(result.messages[0].code !== "0"){
        self.$snotify.error(result.messages[0].message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: self.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )
        return
      }  
      // Script error
      if(scriptResult.code != 0){
        self.$snotify.error( scriptResult.message, "Error",
          {
            showProgressBar: false,
            position: 'rightBottom',
            icon: false,
            timeout: self.notificationDuration,
            closeOnClick: true,
            bodyMaxLength: 1000
          }
        )    
        return
      }
      var cart = {
        isRepeated: false,
        isDefaultSetting: false,
        products: [] 
      }
      self.setCart(cart)

      self.$parent.close()
      self.$router.replace({ name: 'thankYou'})
      self.userInfo.orderNumber = scriptResult.orderNumber

      self.$root.$children[0].$refs.toast.success("Order submitted!", "Success")
      // self.$snotify.success(scriptResult.message, "Success",
      //   {
      //     showProgressBar: false,
      //     position: 'rightBottom',
      //     icon: false,
      //     timeout: self.notificationDuration,
      //     closeOnClick: true,
      //     bodyMaxLength: 1000
      //   },
      // )
    },

    loadCCData: async function(){
      try{
        //load tasks
        var self = this;
        var query = {
          query: 
          [
            { 
              _kftWholesalerID : this.userInfo.userID ,
              isDeactivated: "=",
              zcnCardExpired: "="
            }
          ]
        }
        this.recordID = this.$route.params.id
        
        await axios.post (`proxy.php?/layouts/credit-card/_find`, query)
          .then(response=>{
            var result = response.data.response
            result.data.forEach( record => {
              record.fieldData.isDefault = record.fieldData.isDefault == 1 ? true : false
              this.cc.push(record.fieldData)
            })
          
          
          //set default
          if(this.defaultCardID){
            var defaultCard = this.cc.find( card => card.__kptID == this.defaultCardID)
          }else{
            var defaultCard = this.cc.find( card => card.isDefault == true)
          }

          if (typeof(defaultCard) != 'undefined'){
            this.card = defaultCard
          }

        })
      }catch(e){
        // this.$root.$children[0].$refs.toast.error(e, "Error")
        console.log(e)
      }
    },

    loadShippingData: async function(){
      try{
        //load addresses
        var self = this;
        var query = {
          query: 
          [
            { 
              _kftWholesalerID : this.userInfo.userID,
              isDeactivated: "="
            }
          ]
        }

        //push "New address" option
        this.shippingAddresses.unshift({ 
          name: "New Address...",
          __kptID: "New Address..."
        })
        
        //find addresses
        await axios.post (`proxy.php?/layouts/wholesale-shipping/_find`, query)
          .then(response=>{

            var result = response.data.response
            result.data.forEach( record => {
              record.fieldData.isDefault = record.fieldData.isDefault == 1 ? true : false
              this.shippingAddresses.push(record.fieldData)
            })

          //set default
          var defaultAddress = this.shippingAddresses.find( addresses => addresses.isDefault == true)
          if (typeof(defaultAddress) != 'undefined'){
            this.selectedAddress = defaultAddress
          }else if(this.shippingAddresses.length > 1){
          //if there's no default addresses but there are addresses, it uses index 1
          //index 0 is "New Address..."
          this.selectedAddress = this.shippingAddresses[1]
        }

        })
      }catch(e){
        console.log(e.response)
        var code = e.response.data.messages[0].code
        var message = e.response.data.messages[0].message
        
        if (code == 401){
          this.hasNoShippingAddresses = true
        }
        // this.$root.$children[0].$refs.toast.error(message, "Error")
      }
    },

    update(address){
      //nav to the right panel
      this.isPanelTwo = true
      this.isPanelThree = false
      this.isPanelOne = false
      this.isPanelFour = false
      self.isPanelFive = false
      //set the new address
      this.selectedAddress = address
      //add new address to the list.
      var index = this.shippingAddresses.findIndex(singleAddress => singleAddress.__kptID == address.__kptID)
      if(index == -1){
        //adds it to the list if it's new
        this.shippingAddresses.push(address)
      }else{
        //updates the existing one with their changes.
        this.shippingAddresses[index] = address
      }

    },

    addNewCard(){
      //closes parent window
      this.$parent.close()
      //goes to add credit card form
      this.$router.replace({ name: 'paymentFormCustomer', params:{ id: this.userInfo.userID}, query: { from: this.$route.name }})
    },

    addressCancel(cancel = true){
      if(!cancel && this.selectedAddress.__kptID == "New Address..."){
        return
      }
      //navs to correct panel
      this.isPanelTwo = true
      this.isPanelThree = false
      this.isPanelOne = false
      this.isPanelFour = false
      self.isPanelFive = false
      //set default if they left it on "New Address..."
      if(this.selectedAddress.__kptID == "New Address..."){
        var defaultAddress = this.shippingAddresses.find( addresses => addresses.isDefault == true)
        if (typeof(defaultAddress) != 'undefined'){
          //uses default address
          this.selectedAddress = defaultAddress
        }else if(this.shippingAddresses.length > 1){
          //if there's no default addresses but there are addresses, it uses index 1
          //index 0 is "New Address..."
          this.selectedAddress = this.shippingAddresses[1]
        }
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.divline{
  height: 1px;
  width: 100%;
  background-color: darkgray;
  margin-top: 20px;
  margin-bottom: 20px;
}

.addressFlex{
  display: flex;
  justify-content: flex-start;
}

.addressFlexItem{
  flex: 1;
}

.divider{
  width: 100%;
  border-bottom: solid;
  border-bottom-color: #e4e4e4;
  border-bottom-width: 1px;
  margin-bottom: 5px;
}

.checkoutTable{
  width: 100%;
  font-size: 14px;
}

.checkoutTable td{
  padding-right: 4px;
}

.tableRow{
  text-align: center;
}

.payWithCheck{
  padding-top: 8px;
  padding-bottom: 8px;
}

.topHalf{
  display: flex;
}

.flexDivLeft{
  flex: 1;
  padding-right: 8px
}

.flexDivRight{
  flex: 1;
}

.newccbutton{
  padding-bottom: 15px;
}
.greyOut{
  color:lightgrey;
}
.button-container{
  margin-top: 20px;
}
input{
  margin-bottom: 15px;
}
.is-danger{
    margin-right: 10px;
}
.is-justify-content-space-between{
  justify-content: space-between;
}
  .card-container {
    padding: 2rem;
    margin: 0px 20px 20px 20px;
  }  
  .page-title{
    margin: 0px 10px 0px 10px;
  }
  .columns-button{
     margin: 0px;
  }
  .column-button-left{
    padding: 0px;
  }
  .column-button-right{
    padding: 0px;
    flex: none;
  }
@media only screen and (min-width: 300px) {
  .columns-button{
     margin-top: 30px;
  }
  .column-button-left{
    padding: 0px;
    width: 100%;
  }
  .column-button-right{
    padding: 0px;
    width: 100%;
  }
  .button.is-primary{
    margin-top: 10px;
    width: 100%;
  }
}
</style>